import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Modal } from 'react-bootstrap';
import { getColumnsName, getColumnsByNames, namesAndIds } from './utils/Columns';

const ColumnChooser = ({ columnsName, data, setColumns }) => {

    const [allColumnsName, setAllColumnsName] = useState([]);
    const [selectedItems, setSelectedItems] = useState(columnsName);

    useEffect(() => {
        setAllColumnsName(getColumnsName(data));
    }, [data]);

    useEffect(() => {
        setColumns(getColumnsByNames(columnsName));
    }, [columnsName]);

    const handleCheckboxChange = (colName) => {
        const isSelected = selectedItems.includes(colName);
        let sel = [];
        if (isSelected) {
            sel = selectedItems.filter((item) => item !== colName);
        } else {
            sel = [...selectedItems, colName];
        }
        setSelectedItems(sel);
        setColumns(getColumnsByNames(sel));
    };

    const handleSelectAll = () => {
        let sel = selectedItems.filter(item => !allColumnsName.includes(item));
        let all = [...sel, ...allColumnsName];
        setSelectedItems(all);
        setColumns(getColumnsByNames(all));
    };

    const handleDeselectAll = () => {
        let sel = selectedItems.filter(item => !allColumnsName.includes(item));
        console.log(sel);
        setSelectedItems(sel);
        setColumns(getColumnsByNames(sel));
    };

    const [show, setShow] = useState(false);
    return (
        <>
            <Button variant="primary" onClick={() => setShow(true)}>
                Afficher les colonnes
            </Button>
            <Modal size="xl" show={show} onHide={() => setShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Choix des colonnes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Card>
                        <Card.Body>
                            <div className="mb-3 row">
                                {allColumnsName.map((item, index) => (
                                    <div className='col-3' key={index}>
                                        <Form.Check
                                            type='checkbox'
                                            id={`checkbox-${index}`}
                                            label={item}
                                            checked={selectedItems.includes(item)}
                                            onChange={() => handleCheckboxChange(item)}
                                        />
                                    </div>
                                ))}
                            </div>
                            <Button variant="primary" className="mr-2" onClick={handleSelectAll}>
                                Tout sélectionner
                            </Button>&nbsp;
                            <Button variant="danger" onClick={handleDeselectAll}>
                                Tout désélectionner
                            </Button>
                            {/* <div>
                    <p>Éléments sélectionnés : {selectedItems.join(', ')}</p>
                </div> */}
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>

        </>
    );
}

export default ColumnChooser;
